import React from "react";
import Desktop from "./desktop";
import Mobile from "./mobile";

const ContentSwitch = () => {
  return <Mobile />;
};

export default ContentSwitch;
